export default {
  capture: (eventName, properties = {}) => {
    if (typeof posthog !== 'undefined') {
      posthog.capture(eventName, properties);
    }
  },
  identify: (distinctId, properties = {}) => {
    if (typeof posthog !== 'undefined') {
      posthog.identify(distinctId, properties);
    }
  },
  getFeatureFlag: (key) => {
    if (typeof posthog !== 'undefined' && posthog.getFeatureFlag) {
      return posthog.getFeatureFlag(key);
    }
    return undefined;
  },
  onFeatureFlags: (callback) => {
    if (typeof posthog !== 'undefined' && posthog.onFeatureFlags) {
      return posthog.onFeatureFlags(callback);
    }
    return () => {};
  }
}